<template>
    <div>
        <!-- fixed top bar -->
        <b-navbar
            id="dsv-app-topbar"
            toggleable="lg"
            type="dark"
            variant="dark"
            class="dsv-topbar bg-new-theme"
        >
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-navbar-brand class="px-2">
                <img src="assets/daysmartvet_logo.svg" width="37" />
            </b-navbar-brand>

            <b-collapse id="nav_collapse" is-nav>
                <b-navbar-nav id="nav_module_menu">
                    <b-nav-item
                        v-for="item in filteredMenuItems"
                        :key="item.to"
                        :to="item.to"
                        class="main-menu-item"
                        :active="isActive(item)"
                        :data-top-menu-id="item.topMenuId"
                    >
                        <module-icon class="icon" :name="item.icon" />
                        <span class="label">{{ item.label }}</span>
                    </b-nav-item>
                    <!-- <a
                        v-if="_hasAccess('setting.access')"
                        :href="env.APPS + 'business/business'"
                        :class="[
                            'main-menu-item',
                            {
                                active: $route.path.includes('settings')
                            }
                        ]"
                        data-top-menu-id="settings"
                    >
                        <module-icon class="icon" name="settings" />
                        <span class="label">Settings</span>
                    </a> -->
                </b-navbar-nav>
                <!-- Right aligned nav items -->
                <nav-utility class="ml-auto top-options" />
            </b-collapse>
        </b-navbar>

        <!-- content -->
        <div>
            <slot></slot>
        </div>
    </div>
</template>
<script>
import NavUtility from "@/module/layout/nav-utility";
import ModuleIcon from "@/module/layout/module-icon";
import Helper from "./helper";

export default {
    name: "AppLayoutClassic",
    mixins: [Helper],
    components: {
        NavUtility,
        ModuleIcon
    }
};
</script>
<style lang="scss" scoped>
.dsv-topbar {
    padding: 8px 16px 0;

    #nav_collapse {
        svg.icon {
            margin-right: 7px;
            display: inline;
        }
    }

    a.nav-link {
        svg.icon {
            fill: #fff;
            height: 24px;
            width: 24px;
            transition: transform 0.1s ease;
        }

        .label {
            color: #fff;
        }

        &:hover,
        &.active {
            svg.icon {
                fill: #190d30;
            }

            .label {
                color: #000;
            }
        }

        &:hover {
            svg.icon {
                transform: scale(1.2);
            }
        }
    }
}

@media (min-width: 992px) {
    $primary-top-bar-height: 64px;
    $secondary-top-bar-height: 50px;

    .dsv-topbar {
        margin-bottom: -1px;
        position: fixed;
        z-index: 1002;
        left: 0;
        right: 0;
        height: $primary-top-bar-height;

        #nav_collapse {
            li.main-menu-item {
                width: 5rem;

                a.nav-link {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;

                    svg.icon {
                        margin-right: unset;
                    }

                    span.label {
                        font-size: 1em;
                    }
                }
            }
        }
    }
}
</style>
